import React, { useEffect, useState, useContext } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import ArrowLeft from '@wix/da-ds/pkg/Icons/16x16/ArrowLeft';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import DSModal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import DSPopover from '@wix/da-ds/pkg/popovers/dsPresets/Popover';
import FooterButton from '../../../../Popup/_partials/DialogCardLayout/FooterButton';
import { getFolderNameValidationErrorMessage } from '../../../../utils/isValidFolderName';
import s from './NewCollectionPopup.scss';
var NewCollectionPopup = function (_a) {
    var className = _a.className, folderNameBlacklist = _a.folderNameBlacklist, collectibleDeviation = _a.collectibleDeviation, createCollection = _a.createCollection, isSaving = _a.isSaving, onClose = _a.onClose;
    var t = useTranslation().t;
    var _b = useState(''), title = _b[0], setTitle = _b[1];
    var _c = useState(false), submitted = _c[0], setSubmitted = _c[1];
    var isMobile = useContext(MobileContext);
    var errorMessage = title
        ? getFolderNameValidationErrorMessage(title, t, folderNameBlacklist, false)
        : undefined;
    var onSubmit = function () {
        createCollection(title, collectibleDeviation.deviationId);
        setSubmitted(true);
    };
    useEffect(function () {
        if (submitted && !isSaving) {
            onClose();
        }
    }, [submitted, isSaving, onClose]);
    var content = (React.createElement("div", { className: s['content-wrapper'] },
        React.createElement(TextInput, { autoFocus: true, id: "new-collection-title-input", label: t('newCollectionPopup.input.label'), value: title, validationResult: errorMessage ? 'error' : undefined, details: errorMessage, onChange: function (ev) { return setTitle(ev.target.value); }, onKeyUp: function (ev) {
                if (ev.key === 'Enter') {
                    onSubmit();
                }
            }, readOnly: isSaving })));
    if (isMobile) {
        return (React.createElement(DSModal, { isOpen: true, heading: t('newCollectionPopup.title'), className: s['root'], footerRight: [
                React.createElement(FooterButton, { key: "submit", onClick: onSubmit, size: "small", fullWidth: false, disabled: !title || errorMessage !== undefined, loading: isSaving }, t('newCollectionPopup.button.primary')),
            ], withScrollableContentWrapper: false, onRequestClose: onClose }, content));
    }
    return (React.createElement(DSPopover, { heading: t('newCollectionPopup.title'), className: c(s['root'], className), footerLeft: [
            React.createElement(TextButton, { key: "back", size: "medium", variant: "main", onClick: onClose, disabled: isSaving, icon: ArrowLeft }, t('newCollectionPopup.button.back')),
        ], footerRight: [
            React.createElement(FooterButton, { key: "submit", onClick: onSubmit, size: "small", fullWidth: false, disabled: !title || errorMessage !== undefined, loading: isSaving }, t('newCollectionPopup.button.primary')),
        ], content: content, onCloseClick: onClose }));
};
NewCollectionPopup.displayName = 'NewCollectionPopup';
export default NewCollectionPopup;
//# sourceMappingURL=NewCollectionPopup.js.map